
import { mapActions, mapGetters, mapMutations } from "vuex";
// import marks from '~/apollo/queries/marks'

export default {
  data() {
    return {
      allMarks: false,
      marksArray: []
    };
  },
  async created() {
    if (this.$route.params.category === "cars") {
      this.marksArray = this.markFolderGeneration;
    } else {
      // this.marksArray = await this.getComm()
    }
  },
  props: {
    forChoseModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      markFolderGeneration: "marks/marks/markFolderGeneration",
      popularMarks: "popularMarks/popularMarks/popularMarks"
    }),
    showAllButton() {
      if (this.$device.isMobile && this.marksArray) {
        return this.marksArray.length > 10;
      } else if (this.marksArray) {
        return this.marksArray.length > 21;
      }
    },
    sortedMarks() {
      return this.$_.sortBy(this.marksList, [
        function (mark) {
          return mark.title;
        }
      ]);
    },
    marksList() {
      let marks = [...this.markFolderGeneration];
      let count = 10;

      if (!this.$device.isMobile) {
        count = 17;
      }
      marks = marks.sort(
        (a, b) => parseFloat(b.offers_count) - parseFloat(a.offers_count)
      );
      if (!this.allMarks) {
        return marks.slice(0, count);
      } else {
        marks = marks.sort((a, b) =>
          a.slug.toLowerCase().localeCompare(b.slug.toLowerCase())
        );
        return marks;
      }
    }
  },
  methods: {
    ...mapActions({
      request: "request",
      chooseMark: "modal/modal-choose/chooseMark"
    }),
    ...mapMutations({
      setModalMarks: "modal/modal-marks/setModalMarks"
    }),
    // async getComm() {
    // 	try {
    // 		let response = await this.request({
    // 			query: marks,
    // 			variables: {
    // 				category: 'commercial'
    // 			}
    // 		})
    // 		return response.data.marks

    // 	} catch (error) {
    // 		console.log(error)
    // 	}
    // },
    clickAllMarks() {
      // setTimeout(function () {window.scrollTo(0, -100);}, 1);
      this.allMarks = !this.allMarks;
    }
  }
};
